// It would always give undefined when importing this from
// core so I decided to hard code it in InfoSideBar and cms-boxes/Details.js
export const types = {
    EDIT: 'EDIT',
    INFO: 'INFO',
};
